import React, { useState } from 'react';
import Fila from './Fila';
import PerfilEmpleado from './PerfilEmpleado';

const ListaPerfiles = (props) => {
    const Matriz = props.lista.map((fila, i) => (
                <div className="col-lg-4 col-sm-6 col-xs-12" key={i}>
                    <PerfilEmpleado datos={fila}/>
                </div>
        ));
    return (
        <div className='row'>
            { Matriz}
        </div>
    );
}

export default ListaPerfiles;